<template lang="pug">
div
  Form(:data="physical_location", :isSubmitting="isSubmitting", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import usePhysicalLocationEdit from './usePhysicalLocationEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { show, update, physical_location, isSubmitting } = usePhysicalLocationEdit()

    onMounted(show)

    return {
      physical_location,
      update,
      isSubmitting,
    }
  },
}
</script>
